import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IdLeagueGifts } from "../../constants/IdLeagueGifts";
import { IdStyles } from "../../less/IdStyles";
import { selectCurrentDialogGift, selectCurrentDialogGiftResourceData, selectCurrentDialogGiftType, selectIsTournamentGiftDialogDisabled, } from "../../selectors/selectTournamentRewards";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { RewardItems } from "../generic/items-displayer/RewardItems";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionRequestPackageFromCurrentReward } from "./actionTournament";
import { ButtonDialogLeagueReward } from "./ButtonDialogLeagueReward";
import { DescriptionDialogLeagueReward } from "./DescriptionDialogLeagueReward";
import { LeagueRewardButtonWrapper } from "./LeagueRewardButtonWrapper";
import { LeagueRewardDiscountBadge } from "./LeagueRewardDiscountBadge";
import { mapDialogRewardsTitle } from "./MapDialogRewardsTitle";
export var _DialogLeagueReward = React.memo(function (_a) {
    var currentGift = _a.currentGift, currentGiftItems = _a.currentGiftItems, onClose = _a.onClose, isDisabled = _a.isDisabled, giftType = _a.giftType, onRequest = _a.onRequest;
    var isGoldPackage = giftType === IdLeagueGifts.LeagueGoldGift;
    var mapToUse = mapDialogRewardsTitle.get(currentGift.leagueType) || new Map();
    var title = mapToUse.get(giftType) || IdLoca.empty;
    var buttonType = isGoldPackage
        ? IdLeagueGifts.LeagueGoldGift
        : IdLeagueGifts.LeagueFreeGift;
    return (React.createElement(DialogWrapper, { titleLocaId: title, onClose: onClose, className: IdStyles.ModalBackgroundBuyGold },
        React.createElement("div", { className: "flex flex--wrap flex--guts flex--stack h100 w100" },
            React.createElement(LeagueRewardDiscountBadge, { currentGift: currentGift }),
            React.createElement(DescriptionDialogLeagueReward, { currentGift: currentGift, packageType: giftType }),
            React.createElement(RewardItems, { items: currentGiftItems }),
            React.createElement(LeagueRewardButtonWrapper, { disabled: isDisabled, requiredLeague: currentGift.giftLevel },
                React.createElement(ButtonDialogLeagueReward, { buttonType: buttonType, isDisabled: isDisabled, currentGift: currentGift, onRequest: onRequest })))));
});
var mapState = function (state) {
    var currentGift = selectCurrentDialogGift(state);
    return {
        currentGift: currentGift,
        currentGiftItems: selectCurrentDialogGiftResourceData(state),
        giftType: selectCurrentDialogGiftType(state),
        isDisabled: selectIsTournamentGiftDialogDisabled(state),
    };
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onClose: function () { return actionModalClose(IdModal.LeagueReward); },
        onRequest: actionRequestPackageFromCurrentReward,
    }, dispatch);
};
export var DialogLeagueReward = connect(mapState, mapDispatch)(_DialogLeagueReward);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/DialogLeagueReward.tsx
// module id = 2942
// module chunks = 3